<template>
    <div class="p10">
        <!-- 头部按钮部分 start -->
        <div class="el-row ly-bill-title">
            <el-col :span="6">
                <h1 style="padding-top:5px;">流水详情</h1>
            </el-col>
            <el-col :span="18" class="tr" v-if="infoData.info">
                    <template v-if="operType.length < 1">
                        <template v-if="infoData.info.check_status == 1">
                            <ly-button-time @timeUpdate="timeUpdate" 
                                :infoid="infoData.info.id"
                                :type="22"
                                :date="infoData.info.trade_time" 
                                v-if="buttonConfig.isUpdateTime"></ly-button-time>
                            <!-- 备注的操作 start-->
                            <el-button type="info" size="small" icon="information" 
                                @click="operType = 'remark'" 
                                v-if="buttonConfig.isRemark">
                                备注
                            </el-button>                           
                            <!-- 备注的操作 end -->
                            <el-button type="success" size="small" icon="document" @click="doCheck" v-if="buttonConfig.isCheck"> 
                                对账
                            </el-button>
                            <ly-router-button
                                size="small"
                                :route="'/bill/cashback/edit/' + infoId"
                                type="primary" v-if="buttonConfig.isEdit">
                                    <i class="fa fa-edit"></i>&nbsp;修改
                            </ly-router-button>
                        </template>
                        <template v-else>
                            <el-button type="warning" size="small" v-if="buttonConfig.isBack" @click="backOfPay">
                                <i class="fa fa-reply"></i> 退回
                            </el-button>
                        </template>
                        <ly-router-button size="small">
                            <i class="fa fa-chevron-left"></i>&nbsp;返回
                        </ly-router-button>
                </template>
                <template v-else>
                    <el-button type="primary" size="small" @click="submitRemarkData" :loading="submitLoading">
                        <i class="fa fa-save"></i>&nbsp;提交
                    </el-button>
                    <el-button type="primary" size="small" @click="operType = ''">
                        <i class="fa fa-remove"></i> 取消
                    </el-button>
                </template>
            </el-col>
        </div>
        <!-- 头部按钮部分 end -->
        <el-card class="box-card mt15" v-if="infoData.info">
            <el-row>
                <el-col :span="12">
                    <el-button-group>
                        <template v-if="infoData.info.last_id && infoData.info.last_id > 0">
                            <el-button type="info"  size="small" @click="toggoleInfo(infoData.info.last_id)">
                                <i class="fa fa-chevron-left"></i> 前一张
                            </el-button>
                        </template>
                        <template v-if="infoData.info.next_id && infoData.info.next_id > 0">
                            <el-button type="info"  size="small" @click="toggoleInfo(infoData.info.next_id)">
                                后一张 <i class="fa fa-chevron-right"></i> 
                            </el-button>
                        </template>
                    </el-button-group>
                </el-col>
                <el-col :span="12" class="tr">
                    <template v-if="infoData.info.check_status">
                        <ly-tag tag-category="payconfirm" :tag-status="infoData.info.check_status"></ly-tag>
                    </template>
                    <template v-if="infoData.info.is_jindie == 1">
                        <el-tag type="warning">已发送金蝶</el-tag>
                    </template>
                </el-col>
            </el-row>
            <!-- 单据信息 start -->
            <ly-information 
                :config="infoConfig"
                :data="infoData.info"
                class="mt15">        
            </ly-information>
            <!-- 单据信息 end -->
        </el-card>

        <!-- 客户列表 start -->
        <div v-if="infoData.customer_info">
            <ly-table 
                :head="customerConfig.head" 
                :data="infoData.customer_info.info" 
                :config="customerConfig.config"
                class="mt15">
            </ly-table>
            <div class="ly-info-product_total">
                回款金额小计：{{infoData.customer_info.huikuan_xiaoji}}
            </div>
        </div>
        <!-- 客户列表 end -->
        <!-- 37批加入的备注 start -->
        <template v-if="infoData.info">
            <template v-if="(infoData.info.check_status == 1 && operType == 'remark')|| infoData.info.check_status == 23">
                <ly-confirm-remark 
                    :status="infoData.info.check_status"
                    :data="infoData.remark" 
                    ref="remark">
                </ly-confirm-remark>
            </template>
        </template>
        <!-- 流水备注  end  -->
        <!-- 处理记录 start -->
        <el-card class="box-card mt15">
            <template slot='header'>
            <div>
                <span>处理记录</span>
            </div>
            </template>
            <p class="f12 mt10 ctext" v-for="el in infoData.history">
                {{el}}
             </p>
        </el-card>
        <!-- 处理记录 end -->
    </div>
</template>
<script>
    import {mapGetters} from 'vuex'
    import InfoConfig from './info-config'
    import LyInformation from '@c/information'
    import LyTable from '@c/table'
    import LyTag from '@c/tag'
    import LyRouterButton from '@c/router-button'
    import LyButtonTime from '@c/button-time'
    import LyConfirmRemark from '../confirm/remark.vue'
    export default {
        props: {
            info: Object
        },
        mixins: [
            InfoConfig
        ],
        components: {
            LyTable,
            LyTag,
            LyInformation,
            LyRouterButton,
            LyButtonTime,
            LyConfirmRemark
        },
        data () {
            return {
                submitLoading: false,
                infoId: '0',
                loading: false,
                operType: '',
                infoData: {}, // 详情的数据，包含货品数据、处理记录
                buttonConfig: {} // 按钮的配置
            }
        },
        computed: {
            ...mapGetters('route', [
                'currRoute'
            ])
        },
        watch: {
            'info' () {
                this.infoData = this.info
            }
        },
        mounted () {
            // if (this.info) {
                this.infoId = this.info.info.id
                this.infoData = this.info
                // this.infoData.info['business_time'] = '2018-08-24' 测试
                // 初始化读取配置的
                this.readRouteConfig()
            // } else {
            //     this.queryInfoData()
            // }
        },
        methods: {
            /**
             * 详情页面的切换
             */
            toggoleInfo (id) {
                // 跳转到的路由
                // let path = '/bill/cashback/info/' + id
                let path = '/bill/payconfirm/info/' + id
                this.routerJump(path)
            },
            /**
             * 路由跳转处理
             * @param  {[type]} path [description]
             * @return {[type]}      [description]
             */
            routerJump (path) {
                path = path.replace('#', '')
                this.loading = true
                this.$router.push(path)
            },
            /**
            /**
             * 获取详情的数据
             */
            queryInfoData () {
                // 初始化读取配置的
                this.readRouteConfig()
                // 获取详情的ID
                this.infoId = this.$route.params.id
                this.$api.query('api/fluent' , null, [this.infoId]).then((rs) => {
                    this.loading = false
                    this.infoData = rs
                }).catch((error) => {
                    this.loading = false
                    this.$message({
                        message: error,
                        type: 'warning'
                    })
                })
            },
            /**
             * 进行对账
             * @return {[type]} [description]
             */
            doCheck () {
                this.$confirm('确定提交该流水对账？', '提示', {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                      type: 'info'
                }).then(() => {
                    this.$api.create('api/fluentcashreview', {
                        id: this.infoId
                    }).then((rs) => {
                        this.$message({
                            message: '对账完成',
                            type: 'success'
                        })
                        // 改变当前单据状态
                        // this.$set(this.infoData.info, 'check_status', 21)
                        // 重新获得数据
                        this.queryInfoData()
                    }).catch((msg) => {
                        this.$message({
                            message: msg,
                            type: 'warning'
                        })
                    })
                })
            },
            /**
             * 回退流水处理
             */
            backOfPay () {
                this.$confirm('确定已删除金蝶单据并退回该流水处理？', '提示', {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                      type: 'warning'
                }).then(() => {
                    this.$api.delete('api/fluent/' + this.infoId + '/review/' + this.infoId).then(() => {
                        this.$message({
                            message: '已退回',
                            type: 'success'
                        })
                        // 改变当前单据状态
                        // this.$set(this.infoData.info, 'check_status', 1)
                        // 重新获得数据
                        this.queryInfoData()
                    }).catch((error) => {
                        this.$message({
                            message: error,
                            type: 'warning'
                        })
                    })
                }).catch(() => {})
            },
            /**
             * 读取当前页面的路有配置
             */
            readRouteConfig () {
                // 获得当前页面的配置
                 let routeConfig = this.$utils.readPageConfig(this.currRoute, 'info')
                // 获得button的配置
                if (routeConfig && routeConfig.config) { 
                    this.buttonConfig = routeConfig.config.button ? JSON.parse(routeConfig.config.button || '') : {}
                }
            },
            /**
             * 日期修改之后的事件监听
             */
            timeUpdate () {
                // 详情数据刷新
                this.queryInfoData()
            },
            /**
             * 提交备注的信息
             * @return {[type]} [description]
             */
            submitRemarkData () {
                let el = this.$refs['remark']
                let confirmTxt = '备注'
                if (el.validate()) {
                    this.$confirm('确定提交该流水' + confirmTxt + '?', '提示', {
                          confirmButtonText: '确定',
                          cancelButtonText: '取消',
                          type: 'warning'
                    }).then(() => {
                        let data = {
                            id: this.infoId,
                            oper_type: this.operType
                        }
                        data = Object.assign(data, el.getData())
                        this.submitLoading = true
                        this.$api.create(this.currRoute.api + '/' + this.infoId + '/review', data).then(() => {
                            // 清空状态重新请求数据
                            this.refInfoData()
                        }).catch((error) => {
                            this.submitLoading = false
                            this.$message({
                                message: error,
                                type: 'warning'
                            })
                        })
                    }).catch(() => {})
                }
            },
            /**
             * 数据的重新请求
             * @return {[type]} [description]
             */
            refInfoData () {
                this.loading = true
                this.submitLoading = false
                this.operType = ''
                this.queryInfoData()
            }
        }
    }
</script>

<style>
    .ly-info-product_total {
        border:1px solid #dfe6ec;
        border-top: 0;
        color: #48576a;
        font-size: 14px;
        padding: 8px 10px;
        text-align: right;
    }
</style>